import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-photo-gallery',
  templateUrl: './our-photo-gallery.component.html',
  styleUrls: ['./our-photo-gallery.component.css']
})
export class OurPhotoGalleryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
